import { CSSProperties } from "react";
import { CELL_WIDTH } from "../../../CONSTANTS";


export const ColumnGridContainer = ({children}: {children: React.ReactNode}) => {
	return <div style={columnContainerStyles}>{children}</div>
}
const columnContainerStyles: CSSProperties = {
	// height: '100%',
	// display: 'flex',
	// justifyContent: 'space-between',
	position: 'relative',
	// alignItems: 'center',
	// flexGrow: 1,
	display: "grid",
	// gridTemplateColumns: `repeat(${CELL_WIDTH}px, 3)`,
	gridTemplateColumns: `${CELL_WIDTH}px `.repeat(3),
	gap: 10,
	padding: 10,
};
